import { call, put, all, takeEvery, takeLatest } from 'redux-saga/effects';
import callApi, { abortableCallApi } from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { addNotification } from 'redux/modules/notifications';
import { ADD_PRESCRIBER_RESOURCE_SUCCESS, REMOVE_PRESCRIBER_RESOURCE_SUCCESS } from 'redux/modules/prescribers';

// Actions
export const FETCH_REFERRAL_SOURCES = 'FETCH_REFERRAL_SOURCES';
export const FETCH_REFERRAL_SOURCES_SUCCESS = 'FETCH_REFERRAL_SOURCES_SUCCESS';
export const FETCH_REFERRAL_SOURCES_FAIL = 'FETCH_REFERRAL_SOURCES_FAIL';
export const CLEAR_REFERRAL_SOURCES = 'CLEAR_REFERRAL_SOURCES';
export const CREATE_REFERRAL_SOURCE = 'CREATE_REFERRAL_SOURCE';
export const CREATE_REFERRAL_SOURCE_SUCCESS = 'CREATE_REFERRAL_SOURCE_SUCCESS';
export const CREATE_REFERRAL_SOURCE_FAIL = 'CREATE_REFERRAL_SOURCE_FAIL';
export const UPDATE_REFERRAL_SOURCE = 'UPDATE_REFERRAL_SOURCE';
export const UPDATE_REFERRAL_SOURCE_SUCCESS = 'UPDATE_REFERRAL_SOURCE_SUCCESS';
export const UPDATE_REFERRAL_SOURCE_FAIL = 'UPDATE_REFERRAL_SOURCE_FAIL';
export const DELETE_REFERRAL_SOURCE = 'DELETE_REFERRAL_SOURCE';
export const DELETE_REFERRAL_SOURCE_SUCCESS = 'DELETE_REFERRAL_SOURCE_SUCCESS';
export const DELETE_REFERRAL_SOURCE_FAIL = 'DELETE_REFERRAL_SOURCE_FAIL';
export const CREATE_REFERRAL_SOURCE_CONTACT = 'CREATE_REFERRAL_SOURCE_CONTACT';
export const CREATE_REFERRAL_SOURCE_CONTACT_SUCCESS = 'CREATE_REFERRAL_SOURCE_CONTACT_SUCCESS';
export const CREATE_REFERRAL_SOURCE_CONTACT_FAIL = 'CREATE_REFERRAL_SOURCE_CONTACT_FAIL';
export const UPDATE_REFERRAL_SOURCE_CONTACT = 'UPDATE_REFERRAL_SOURCE_CONTACT';
export const UPDATE_REFERRAL_SOURCE_CONTACT_SUCCESS = 'UPDATE_REFERRAL_SOURCE_CONTACT_SUCCESS';
export const UPDATE_REFERRAL_SOURCE_CONTACT_FAIL = 'UPDATE_REFERRAL_SOURCE_CONTACT_FAIL';
export const DELETE_REFERRAL_SOURCE_CONTACT = 'DELETE_REFERRAL_SOURCE_CONTACT';
export const DELETE_REFERRAL_SOURCE_CONTACT_SUCCESS = 'DELETE_REFERRAL_SOURCE_CONTACT_SUCCESS';
export const DELETE_REFERRAL_SOURCE_CONTACT_FAIL = 'DELETE_REFERRAL_SOURCE_CONTACT_FAIL';
export const ADD_REFERRAL_SOURCE_RESOURCE = 'ADD_REFERRAL_SOURCE_RESOURCE';
export const ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS = 'ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS';
export const ADD_REFERRAL_SOURCE_RESOURCE_FAIL = 'ADD_REFERRAL_SOURCE_RESOURCE_FAIL';
export const REMOVE_REFERRAL_SOURCE_RESOURCE = 'REMOVE_REFERRAL_SOURCE_RESOURCE';
export const REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS = 'REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS';
export const REMOVE_REFERRAL_SOURCE_RESOURCE_FAIL = 'REMOVE_REFERRAL_SOURCE_RESOURCE_FAIL';


// Reducer
export default function referralSourcesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_REFERRAL_SOURCES:
      return {
        ...state,
        ...triggerLoading && state.loading <= 0 ? { loading: state.loading + 1 } : {},
      };
    case FETCH_REFERRAL_SOURCES_SUCCESS: {
      if (payload.push) {
        const newData = [
          ...state.data.slice(0, state.data.length),
          ...payload.data.slice(0, payload.data.length),
        ];
        return {
          ...state,
          count: payload.count,
          data: newData,
          ...triggerLoading ? { loading: state.loading - 1 } : {},
        };
      }
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_REFERRAL_SOURCES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CLEAR_REFERRAL_SOURCES:
      return {
        ...state,
        data: [],
        count: 0,
      };
    case CREATE_REFERRAL_SOURCE_SUCCESS: {
      const newData = [
        ...state.data.slice(0, state.data.length),
        payload,
      ];
      return {
        ...state,
        count: state.count + 1,
        data: newData,
      };
    }
    case UPDATE_REFERRAL_SOURCE_SUCCESS:
    case ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS:
    case REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem.ID !== payload.ID) {
          return dataItem;
        }
        return {
          ...dataItem,
          ...payload,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_REFERRAL_SOURCE_SUCCESS: {
      const index = state.data.findIndex(dataItem => dataItem.ID === payload.ID);
      const newData = [
        ...state.data.slice(0, index),
        ...state.data.slice(index + 1),
      ];
      return {
        ...state,
        count: state.count - 1,
        data: newData,
      };
    }
    case CREATE_REFERRAL_SOURCE_CONTACT_SUCCESS: {
      const newData = state.data.map((item) => {
        const createdReferralSourceContact = payload.data.filter(contactItem =>
          contactItem['Referral Source ID'] === item.ID);
        if (createdReferralSourceContact.length > 0) {
          return {
            ...item,
            'Referral Source Contact': [
              ...item['Referral Source Contact'],
              ...createdReferralSourceContact,
            ],
          };
        }
        return item;
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_REFERRAL_SOURCE_CONTACT_SUCCESS: {
      const newData = state.data.map((item) => {
        const newReferralSourceContact = item['Referral Source Contact'].map((contactItem) => {
          const newContact = payload.data.find(updatedContactItem =>
            updatedContactItem.ID === contactItem.ID);
          return newContact || contactItem;
        });
        return {
          ...item,
          'Referral Source Contact': newReferralSourceContact,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_REFERRAL_SOURCE_CONTACT_SUCCESS: {
      const newData = state.data.map((item) => {
        const newReferralSourceContact = item['Referral Source Contact'].filter(contactItem =>
          !payload.data.find(deletedContactItem =>
            deletedContactItem.ID === contactItem.ID));
        return {
          ...item,
          'Referral Source Contact': newReferralSourceContact,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case ADD_PRESCRIBER_RESOURCE_SUCCESS: {
      const newData = state.data.map((item) => {
        if (payload['Referral Source'].filter(referralSourceItem => referralSourceItem.ID === item.ID).length > 0
          && item.Prescriber.findIndex(prescriberItem => prescriberItem.ID === payload.ID) === -1) {
          return {
            ...item,
            Prescriber: [
              ...item.Prescriber,
              payload,
            ],
          };
        } else {
          return item;
        }
      });
      return {
        ...state,
        data: newData,
      };
    }
    case REMOVE_PRESCRIBER_RESOURCE_SUCCESS: {
      const newData = state.data.map((item) => {
        const removedPrescriberIndex = item.Prescriber.findIndex(prescriberItem =>
          prescriberItem.ID === payload.ID && payload['Referral Source'].filter(referralSourceItem => referralSourceItem.ID === item.ID).length === 0);
        if (removedPrescriberIndex === -1) {
          return item;
        } else {
          return {
            ...item,
            Prescriber: [
              ...item.Prescriber.slice(0, removedPrescriberIndex),
              ...item.Prescriber.slice(removedPrescriberIndex + 1),
            ],
          };
        }
      });
      return {
        ...state,
        data: newData,
      };
    }
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchReferralSources(payload) {
  return { type: FETCH_REFERRAL_SOURCES, payload };
}

export function fetchReferralSourcesSuccess(payload) {
  return { type: FETCH_REFERRAL_SOURCES_SUCCESS, payload };
}

export function fetchReferralSourcesFail(payload) {
  return { type: FETCH_REFERRAL_SOURCES_FAIL, payload };
}

export function clearReferralSources(payload) {
  return { type: CLEAR_REFERRAL_SOURCES, payload };
}

export function createReferralSource(payload) {
  return { type: CREATE_REFERRAL_SOURCE, payload };
}

export function createReferralSourceSuccess(payload) {
  return { type: CREATE_REFERRAL_SOURCE_SUCCESS, payload };
}

export function createReferralSourceFail(payload) {
  return { type: CREATE_REFERRAL_SOURCE_FAIL, payload };
}

export function updateReferralSource(payload) {
  return { type: UPDATE_REFERRAL_SOURCE, payload };
}

export function updateReferralSourceSuccess(payload) {
  return { type: UPDATE_REFERRAL_SOURCE_SUCCESS, payload };
}

export function updateReferralSourceFail(payload) {
  return { type: UPDATE_REFERRAL_SOURCE_FAIL, payload };
}

export function deleteReferralSource(payload) {
  return { type: DELETE_REFERRAL_SOURCE, payload };
}

export function deleteReferralSourceSuccess(payload) {
  return { type: DELETE_REFERRAL_SOURCE_SUCCESS, payload };
}

export function deleteReferralSourceFail(payload) {
  return { type: DELETE_REFERRAL_SOURCE_FAIL, payload };
}

export function createReferralSourceContact(payload) {
  return { type: CREATE_REFERRAL_SOURCE_CONTACT, payload };
}

export function createReferralSourceContactSuccess(payload) {
  return { type: CREATE_REFERRAL_SOURCE_CONTACT_SUCCESS, payload };
}

export function createReferralSourceContactFail(payload) {
  return { type: CREATE_REFERRAL_SOURCE_CONTACT_FAIL, payload };
}

export function updateReferralSourceContact(payload) {
  return { type: UPDATE_REFERRAL_SOURCE_CONTACT, payload };
}

export function updateReferralSourceContactSuccess(payload) {
  return { type: UPDATE_REFERRAL_SOURCE_CONTACT_SUCCESS, payload };
}

export function updateReferralSourceContactFail(payload) {
  return { type: UPDATE_REFERRAL_SOURCE_CONTACT_FAIL, payload };
}

export function deleteReferralSourceContact(payload) {
  return { type: DELETE_REFERRAL_SOURCE_CONTACT, payload };
}

export function deleteReferralSourceContactSuccess(payload) {
  return { type: DELETE_REFERRAL_SOURCE_CONTACT_SUCCESS, payload };
}

export function deleteReferralSourceContactFail(payload) {
  return { type: DELETE_REFERRAL_SOURCE_CONTACT_FAIL, payload };
}

export function addReferralSourceResource(payload) {
  return { type: ADD_REFERRAL_SOURCE_RESOURCE, payload };
}

export function addReferralSourceResourceSuccess(payload) {
  return { type: ADD_REFERRAL_SOURCE_RESOURCE_SUCCESS, payload };
}

export function addReferralSourceResourceFail(payload) {
  return { type: ADD_REFERRAL_SOURCE_RESOURCE_FAIL, payload };
}

export function removeReferralSourceResource(payload) {
  return { type: REMOVE_REFERRAL_SOURCE_RESOURCE, payload };
}

export function removeReferralSourceResourceSuccess(payload) {
  return { type: REMOVE_REFERRAL_SOURCE_RESOURCE_SUCCESS, payload };
}

export function removeReferralSourceResourceFail(payload) {
  return { type: REMOVE_REFERRAL_SOURCE_RESOURCE_FAIL, payload };
}

// Requests

let abort;

export function requestFetchReferralSources({ limit, offset }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi(`resource/referral_source/?limit=${limit}&offset=${offset}`);
  abort = request.abort;
  return request.res;
}

export function requestSearchReferralSources({ limit, offset, filters }) {
  if (abort) {
    abort();
    abort = null;
  }
  const request = abortableCallApi('resource/referral_source/search/', 'POST', {
    filters,
    sort_by: [
      {
        name: 'Name of source',
        sort: 'asc',
      },
      {
        name: 'ID',
        sort: 'asc',
      },
    ],
    limit,
    offset,
  });
  abort = request.abort;
  return request.res;
}

export function requestCreateReferralSource(payload) {
  return callApi('resource/referral_source/', 'POST', payload);
}

export function requestUpdateReferralSource(payload) {
  return callApi('resource/referral_source/', 'PATCH', payload);
}

export function requestDeleteReferralSource(payload) {
  return callApi(`resource/referral_source/?id=${payload}`, 'DELETE');
}

export function requestCreateReferralSourceContact(payload) {
  return callApi('resource/referral_source_contact/', 'POST', payload);
}

export function requestUpdateReferralSourceContact(payload) {
  return callApi('resource/referral_source_contact/', 'PATCH', payload);
}

export function requestDeleteReferralSourceContact(payload) {
  return callApi(`resource/referral_source_contact/?id=${payload}`, 'DELETE');
}

export function requestAddReferralSourceResource(payload) {
  return callApi('resource/referral_source/change_resource/add/', 'POST', payload);
}

export function requestRemoveReferralSourceResource(payload) {
  return callApi('resource/referral_source/change_resource/remove/', 'POST', payload);
}

// Sagas
function* fetchReferralSourcesSaga(action) {
  const { triggerLoading, filters } = action.payload;
  try {
    const res = filters
      ? yield call(requestSearchReferralSources, action.payload)
      : yield call(requestFetchReferralSources, action.payload);
    yield put(fetchReferralSourcesSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
      ...action.payload.push ? { push: true } : {},
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchReferralSourcesFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

function* createReferralSourceSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestCreateReferralSource, values);
    yield put(createReferralSourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'New referral source successfully added',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    if (err.data && err.data.error
      && err.data.error === 'Unique check fail: object with same \'name\' already exists') {
      const error = {
        error: 'Referral Source with identical Name already exist',
      };
      yield put(createReferralSourceFail(error));
      if (reject) {
        reject(error);
      }
    } else {
      yield put(createReferralSourceFail(err.data));
      if (reject) {
        reject(err.data);
      }
    }
  }
}

function* updateReferralSourceSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield call(requestUpdateReferralSource, values);
    yield put(updateReferralSourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Referral source successfully updated',
      variant: 'success',
    }));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    if (err.data && err.data.error
      && err.data.error === 'Unique check fail: object with same \'name\' already exists') {
      const error = {
        error: 'Referral Source with identical Name already exist',
      };
      yield put(updateReferralSourceFail(error));
      if (reject) {
        reject(error);
      }
    } else {
      yield put(updateReferralSourceFail(err.data));
      if (reject) {
        reject(err.data);
      }
    }
  }
}

function* deleteReferralSourceSaga(action) {
  const { ID } = action.payload;
  try {
    const res = yield call(requestDeleteReferralSource, ID);
    yield put(deleteReferralSourceSuccess({ ID }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    yield put(addNotification({
      message: 'Referral source successfully deleted',
      variant: 'success',
    }));
  } catch (err) {
    yield put(deleteReferralSourceFail(err.data));
    yield put(addNotification({
      message: 'Failed to delete referral source',
      variant: 'warning',
    }));
  }
}

function* createReferralSourceContactSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield all(values['Referral Source Contact'].map(item =>
      call(requestCreateReferralSourceContact, {
        ...item,
        'Referral Source ID': values['Referral Source ID'],
      }),
    ));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    yield put(createReferralSourceContactSuccess({ data: res.map(item => item.data) }));
    if (resolve) {
      resolve(res.map(item => item.data));
    }
  } catch (err) {
    yield put(createReferralSourceContactFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* updateReferralSourceContactSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield all(values['Referral Source Contact'].map(item =>
      call(requestUpdateReferralSourceContact, item),
    ));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    yield put(updateReferralSourceContactSuccess({ data: res.map(item => item.data) }));
    if (resolve) {
      resolve(res.map(item => item.data));
    }
  } catch (err) {
    yield put(updateReferralSourceContactFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* deleteReferralSourceContactSaga(action) {
  const {
    values,
    resolve,
    reject,
  } = action.payload;
  try {
    const res = yield all(values['Referral Source Contact'].map(item =>
      call(requestDeleteReferralSourceContact, item.ID),
    ));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res[0].app_info));
    yield put(deleteReferralSourceContactSuccess({ data: values['Referral Source Contact'] }));
    if (resolve) {
      resolve(values['Referral Source Contact']);
    }
  } catch (err) {
    yield put(deleteReferralSourceContactFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* addReferralSourceResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestAddReferralSourceResource, values);
    yield put(addReferralSourceResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(addReferralSourceResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

function* removeReferralSourceResourceSaga(action) {
  const {
    resolve,
    reject,
    values,
  } = action.payload;
  try {
    const res = yield call(requestRemoveReferralSourceResource, values);
    yield put(removeReferralSourceResourceSuccess(res.data));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(res.data);
    }
  } catch (err) {
    yield put(removeReferralSourceResourceFail(err.data));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* referralSourcesSaga() {
  yield takeLatest(FETCH_REFERRAL_SOURCES, fetchReferralSourcesSaga);
  yield takeEvery(CREATE_REFERRAL_SOURCE, createReferralSourceSaga);
  yield takeEvery(UPDATE_REFERRAL_SOURCE, updateReferralSourceSaga);
  yield takeEvery(DELETE_REFERRAL_SOURCE, deleteReferralSourceSaga);
  yield takeEvery(CREATE_REFERRAL_SOURCE_CONTACT, createReferralSourceContactSaga);
  yield takeEvery(UPDATE_REFERRAL_SOURCE_CONTACT, updateReferralSourceContactSaga);
  yield takeEvery(ADD_REFERRAL_SOURCE_RESOURCE, addReferralSourceResourceSaga);
  yield takeEvery(REMOVE_REFERRAL_SOURCE_RESOURCE, removeReferralSourceResourceSaga);
  yield takeEvery(DELETE_REFERRAL_SOURCE_CONTACT, deleteReferralSourceContactSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/referralSources.js